import React, { Component } from 'react';
import { List, Icon, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

class WhatsappGotoConvo extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            phone : this.props.phone
         }
    }

    
    componentDidMount(){
     //   console.log("whatx1 +++  componentDidMount ++ clean phone:"+this.props.order.phone)
     //   console.log("whatx12 clean phone:"+this.props.order.phone)
     let newPhone = "256"+ "none";

     if(this.props.order && this.props.order.phone){
        newPhone = "256"+ this.props.order.phone.replace(/^0+/, '');
        console.log("whatx123 clean phone:"+this.props.order.phone)
     }else{
        console.log("whatx124 phone not available..using none")
     }

      //  console.log("whatx12 clean phone:"+newPhone)

        this.setState({
            phone: newPhone
        })
    }

    cleanPhone = () => {
      //  console.log("whatx1 clean phone:"+this.props.order.phone)
        let newPhone = "256"+ this.props.order.phone.replace(/^0+/, '');
       // console.log("whatx12 clean phone:"+newPhone)
        return newPhone
    }
    
    render() { 
        return (  
        <div>
            <Button fluid color="green"> <Icon name='whatsapp' />  <Link to={'/dashboard/singleChat/' + this.state.phone} target="_blank">VIEW WHATSAPP CHATS</Link></Button> 

            {/* <Link to={'/dashboard/searchReceiptNumber'}>Search For Receipt</Link> */}
            
        </div>
        )
    }
}
 
export default WhatsappGotoConvo;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/WhatsappGotoConvo.js